/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 12:39:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-09 14:50:44
 * @FilePath: /unifyxp-v2-store-portal/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb.tsx
 */
import React from 'react';
import css from './css.less';
import Button from '../../../components/Antd/Button/Button';
import { LeftOutlined } from '@ant-design/icons';
import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  goBack: () => void;
  breadcrumbData: { url: string; name: string }[];
}
const TopLeft = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { breadcrumbData, goBack } = props;
  return (
    <div className={css.topLeft}>
      <Button
        onClick={() => goBack()}
        icon={<LeftOutlined />}
        className={css.button}>
        {getI18n('general.back')}
      </Button>
      <Breadcrumb className={css.breadcrumb} breadcrumbData={breadcrumbData} />
    </div>
  );
};
export default TopLeft;
